import { Panel } from '@rta/rta-blueprint-library';

/**
 * Checks if a panel is a "utility panel"
 * Uses the panel.isUtilityPanel property which automatically checks for showLabel items
 */
export const checkIsUtilityPanel = (panel: Panel): boolean => {
	return panel.isUtilityPanel;
};
